import cx from 'classnames';
import React from 'react';
import styled, { keyframes } from 'styled-components';
// import { FeatureCard } from './feature-card';


const orbColor = keyframes`
  0%, 100% { background: rgba(78,95,253,0.18); }
  33% { background: rgba(220,50,47,0.16); }
  66% { background: rgba(139,92,246,0.18); }
`;

const stripeFlow = keyframes`
  0% { background-position: 0% 0%; }
  100% { background-position: 0% 200%; }
`;


const Container = styled.div`
  position: relative;
  height: 100%;
  background:rgb(3, 0, 25);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const GridOverlay = styled.div`
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  z-index: 1;

  mask-image: radial-gradient(
    ellipse 50% 50% at 50% 50%,
    transparent 0%,
    transparent 30%,
    black 80%
  );
`;

const Orb = styled.div`
  position: absolute;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  filter: blur(120px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ${orbColor} 12s ease-in-out infinite;
`;

const Stripe = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 5px;
  height: 100%;
  background: linear-gradient(
    180deg,
    #4e5ffd,
    #3d4ef0,
    #06b6d4,
    #8b5cf6,
    #4e5ffd
  );
  background-size: 100% 300%;
  animation: ${stripeFlow} 5s linear infinite;
  z-index: 10;
`;

const Content = styled.div`
  position: relative;
  z-index: 5;
  max-width: 380px;
  color: #fff;
`;

const Logo = styled.img`
  height: 52px;
  transform: translateX(-10%);
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 16px;
`;


export const Ornamentation = ({
  className
}: Ornamentation.Props): React.ReactElement => (
  <Container className={cx(className)}>
    <GridOverlay />
    <Orb />
    <Stripe />

    <Content>
      <Logo src="assets/entrance-light.svg" />

      <Title>
        The all-in-one video production solution.
      </Title>

      {/* <FeatureCard
        title=" Closed Captioning now live! →"
        description=""
        link="https://mylivecontrol.zendesk.com/hc/en-us/articles/40057045300375-Closed-Captioning"
      /> */}
    </Content>
  </Container>
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace Ornamentation {
  export interface Props {
    className?: string;
  }
}

